"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DataTable;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTable = require("react-table");

var _useFlexLayout = _interopRequireDefault(require("./useFlexLayout"));

var _Base = require("./Base");

var _HeaderCell = require("./HeaderCell");

var _ui_elements = require("../../ui_elements");

var _ = require("..");

var _base = require("../../base");

var _inflector = _interopRequireDefault(require("../../utils/inflector"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function getServerPaginationProps(serverPagination) {
  return {
    manualSorting: serverPagination,
    manualFilters: serverPagination,
    manualPagination: serverPagination,
    disableMultiSort: serverPagination,
    disableGrouping: serverPagination
  };
}

function DataTable(props) {
  var pageSize = props.pageSize,
      recordNoun = props.recordNoun,
      onControlsChange = props.onControlsChange,
      serverPagination = props.serverPagination,
      pageCount = props.pageCount,
      totalRecordCount = props.totalRecordCount,
      showDelete = props.showDelete,
      onDeleteRow = props.onDeleteRow,
      defaultSortBy = props.defaultSortBy,
      defaultFilters = props.defaultFilters,
      defaultPageIndex = props.defaultPageIndex;
  var defaultTableState = (0, _reactTable.useTableState)({
    pageSize: pageSize,
    pageCount: pageCount,
    sortBy: defaultSortBy,
    filters: defaultFilters,
    pageIndex: defaultPageIndex
  });

  var _defaultTableState = _slicedToArray(defaultTableState, 1),
      _defaultTableState$ = _defaultTableState[0],
      sortBy = _defaultTableState$.sortBy,
      filters = _defaultTableState$.filters,
      pageIndex = _defaultTableState$.pageIndex;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      confirmDeleteIndex = _useState2[0],
      setConfirmDeleteIndex = _useState2[1];

  var hideConfirmDelete = function hideConfirmDelete() {
    return setConfirmDeleteIndex(null);
  };

  var isBeingDeleted = function isBeingDeleted(index) {
    return confirmDeleteIndex === index;
  };

  var showConfirmDelete = function showConfirmDelete(index) {
    setConfirmDeleteIndex(index);
  };

  (0, _react.useEffect)(function () {
    onControlsChange({
      sortBy: sortBy,
      filters: filters,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageCount: pageCount
    });
  }, [sortBy, filters, pageIndex, pageSize, onControlsChange, serverPagination, pageCount]);
  var instance = (0, _reactTable.useTable)(_objectSpread({}, props, {}, getServerPaginationProps(serverPagination), {
    disablePageResetOnDataChange: true,
    state: defaultTableState
  }), _reactTable.useSortBy, _useFlexLayout.default, _reactTable.useFilters, _reactTable.usePagination);
  var data = instance.data,
      getTableProps = instance.getTableProps,
      headerGroups = instance.headerGroups,
      rows = instance.rows,
      page = instance.page,
      prepareRow = instance.prepareRow,
      instancePageCount = instance.pageCount,
      gotoPage = instance.gotoPage;
  var recordNounPluralized = new _inflector.default().pluralize(recordNoun || 'record', rows.length, {
    showNumber: false
  });

  var renderRow = function renderRow(row, index) {
    var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    prepareRow(row);

    var cellContent = function cellContent(cell) {
      return cell.column.noTranslate ? _react.default.createElement(_base.NoTranslate, null, cell.render('Cell')) : cell.render('Cell');
    };

    var cells = function cells() {
      return row.cells.map(function (cell) {
        return _react.default.createElement(_Base.Cell, _extends({}, cell.getCellProps(), {
          "data-title": cell.column.Header
        }), _react.default.createElement(_Base.CellInnerWrapper, null, cellContent(cell)));
      });
    };

    return _react.default.createElement(_Base.Row, _extends({}, row.getRowProps({
      style: style,
      even: index % 2
    }), {
      showDeleteConfirmation: isBeingDeleted(index),
      onDeleteCancel: hideConfirmDelete,
      onDeleteConfirm: function onDeleteConfirm() {
        onDeleteRow(row);
        hideConfirmDelete();
      }
    }), cells(), _react.default.createElement(_.Toggleable, {
      show: showDelete
    }, _react.default.createElement(_Base.DeleteCell, {
      onDelete: function onDelete() {
        return showConfirmDelete(index);
      }
    })));
  };

  var tableBody = page && page.length ? page.map(function (row, i) {
    return renderRow(row, i);
  }) : null;
  return _react.default.createElement("div", null, _react.default.createElement(_Base.Table, _extends({}, getTableProps(), {
    showDelete: showDelete
  }), _react.default.createElement(_Base.TotalRow, null, _react.default.createElement(_Base.Cell, null, serverPagination ? totalRecordCount : rows.length, " Total ", recordNounPluralized)), headerGroups.map(function (headerGroup) {
    return _react.default.createElement(_Base.HeaderRow, headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return _react.default.createElement(_HeaderCell.HeaderCell, {
        column: column,
        data: data,
        filters: filters,
        key: column.id
      });
    }), _react.default.createElement(_.Toggleable, {
      show: showDelete
    }, _react.default.createElement(_HeaderCell.DeleteHeaderCell, null)));
  }), tableBody, instancePageCount > 1 && _react.default.createElement(_ui_elements.Pagination, {
    handlePageChange: function handlePageChange(e) {
      gotoPage(e.target.dataset.page - 1);
    },
    currentPage: pageIndex + 1,
    numPages: instancePageCount
  })));
}

DataTable.defaultProps = {
  recordNoun: '',
  pageSize: 15,
  onControlsChange: function onControlsChange() {},
  serverPagination: false,
  pageCount: 1,
  totalRecordCount: 0,
  onDeleteRow: function onDeleteRow() {},
  showDelete: false,
  defaultSortBy: [],
  defaultFilters: {},
  defaultPageIndex: 0
};
DataTable.propTypes = {
  recordNoun: _propTypes.default.string,
  pageSize: _propTypes.default.number,
  onControlsChange: _propTypes.default.func,
  serverPagination: _propTypes.default.bool,
  pageCount: _propTypes.default.number,
  totalRecordCount: _propTypes.default.number,
  onDeleteRow: _propTypes.default.func,
  showDelete: _propTypes.default.bool,
  defaultSortBy: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    desc: _propTypes.default.bool
  })),
  // eslint-disable-next-line react/forbid-prop-types
  defaultFilters: _propTypes.default.object,
  defaultPageIndex: _propTypes.default.number
};